import React from 'react';

export const ServerSideRenderingError = () => {
  if(!window.IS_DEV) return null;
  if(typeof window == 'undefined') return null;
  if(!window.serverSideRenderingError) return null;

  return (
    <div className='absolute left-0 right-0 h-7 text-base p-5 bg-red-500 text-white z-[9999999]'>
      Server side rendering error occurred
    </div>
  );
};
